import * as React from 'react';
import { Route } from 'react-router-dom';
import { InterviewList } from './project/InterviewList';

export const customRoutes = [
  <Route exact path="/project/:id" component={InterviewList} />,
];
